<template>
    <div class="product-detail">
        <!-- 自定义头部（参考首页风格） -->
        <div class="custom-header">
            <div class="back-btn" @click="goBack">
                <span class="icon">←</span>
            </div>
            <div class="header-title">商品详情</div>
            <div class="share-btn">
            </div>
        </div>

        <!-- 商品主图（轮播简化版，可左右滑动） -->
        <div class="image-gallery">
            <div class="scroll-container" ref="scrollContainer">
                <div class="image-list">
                    <div v-for="(img, idx) in product.images" :key="idx" class="image-item">
                        <img :src="img" alt="商品图片" />
                        <div class="image-counter">{{ idx + 1 }}/{{ product.images.length }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 商品信息卡片 -->
        <div class="info-card">
            <div class="price-tit">
                <div class="price-content">
                    <span style="margin-right: 6px;">52积分+￥0.01 <span style="font-size: 10px;">/个</span> </span>
                    <span class="old-price" style="color: #fff;">￥16.9</span>
                </div>
                <div class="price-btn">
                    <span>
                        臻选·匠心·好评 >
                    </span>
                </div>
            </div>

            <div class="price-row">
                <div class="rent-price">
                    <div class="currency">
                        <div class="price-num">新人首单价</div>
                        <div class="price-num">券 | 新客折上5折</div>
                        <div class="price-num">券 | 满59减20</div>
                    </div>
                    <div class="unit">领券></div>
                </div>

                <div class="collect-btn">
                    <div class="collect-icon">时令</div>
                    <div class="title">荣事达电饭煲5L</div>
                </div>
                <!-- 特色标签（根据设计图：冷藏/脆甜品种/最大果径） -->
                <div class="subtitle">
                    <div class="feature-tags">
                        <div class="tag-item">
                            <div class="tag-name"
                                style="color: #0179E2;font-size: 11px;display: flex;align-items: center;"> <img
                                    src="/static/product/leng.png" alt=""
                                    style="width: 10px;height: 12px;margin-right: 2px;"><span>冷藏</span></div>
                            <div class="tag-desc">储存条件</div>
                        </div>
                        <div class="division"></div>
                        <div class="tag-item">
                            <div class="tag-name">脆甜品种</div>
                            <div class="tag-desc">推荐理由</div>
                        </div>
                        <div class="division"></div>
                        <div class="tag-item">
                            <div class="tag-name">在售最大果径</div>
                            <div class="tag-desc">推荐理由</div>
                        </div>
                    </div>
                    <div class="ranking">
                        <div class="ranking-num">
                            <div class="ranking-tit">上榜</div>
                            <div class="ranking-cont">蓝莓热卖榜</div>
                        </div>
                        <div class="ranking-icon">></div>
                    </div>
                </div>
                <div class="desc-card">
                    高山种植，精选品种，蓝莓风味浓郁，每一口都萦绕在舌尖
                </div>
            </div>
        </div>

        <div class="shop-card">
            <div class="shop-info">
                <img src="/static/product/fruit.png" alt="" style="width: 52px;height: 49px;margin-right: 8px;">
                <div class="shop-left">
                    <div class="shop-name">春日烧烤-水果/烘焙</div>
                    <div class="shop-score">物超所值·品质可靠·值得回购</div>
                </div>
            </div>
            <div class="shop-right">去逛逛</div>
        </div>

        <!-- 相似商品/经常一起买 切换标签区域 -->
        <div class="similar-card">
            <!-- 选项卡头部 -->
            <div class="similar-tabs">
                <div class="tab-item" @click="activeSimilarTab = 'similar'">
                    <div class="tab" :class="{ active: activeSimilarTab === 'similar' }">相似商品</div>
                    <div v-if="activeSimilarTab === 'similar'" class="tab-bar"></div>
                </div>
                <div class="tab-item" @click="activeSimilarTab = 'often'">
                    <div class="tab" :class="{ active: activeSimilarTab === 'often' }">经常一起买</div>
                    <div v-if="activeSimilarTab === 'often'" class="tab-bar"></div>
                </div>
            </div>

            <!-- 相似商品网格 -->
            <div v-if="activeSimilarTab === 'similar'" class="similar-grid">
                <div class="similar-item" v-for="item in similarProductList" :key="item.id"
                    @click="gotoProduct(item.id)">
                    <img :src="item.image" class="similar-img" />
                    <div class="similar-title">{{ item.title }}</div>
                    <div class="similar-spec">{{ item.spec }}</div>
                    <div style="display: flex;margin-left: 8px;">
                        <div class="price-tag">新人首单价</div>
                        <div class="price-tag">近30天最低价</div>
                    </div>
                    <div class="price-box">
                        <div style="display: flex;flex-direction: column;align-items: flex-start;">
                            <div class="current-price"><span style="font-size: 10px;">¥</span>{{
                                item.price
                                }}</div>
                            <div class="old-price">¥{{ item.oldPrice }}</div>
                        </div>
                        <div class="add">+</div>
                    </div>
                </div>
            </div>

            <!-- 经常一起买网格 -->
            <div v-else class="similar-grid">
                <div class="similar-item" v-for="item in oftenBuyList" :key="item.id" @click="gotoProduct(item.id)">
                    <img :src="item.image" class="similar-img" />
                    <div class="similar-title">{{ item.title }}</div>
                    <div class="similar-spec">{{ item.spec }}</div>
                    <div style="display: flex;margin-left: 8px;">
                        <div class="price-tag">新人首单价</div>
                        <div class="price-tag">近30天最低价</div>
                    </div>
                    <div class="price-box">
                        <div style="display: flex;flex-direction: column;align-items: flex-start;">
                            <div class="current-price"><span style="font-size: 10px;">¥</span>{{
                                item.price
                                }}</div>
                            <div class="old-price">¥{{ item.oldPrice }}</div>
                        </div>
                        <div class="add">+</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 商品详情图文区域（占位） -->
        <div class="detail-card">
            <img src="/static/product/prodetail.png" class="detail-img" />
        </div>

        <!-- 底部操作栏（立即购买按钮） -->
        <div class="bottom-bar">
            <div class="bottom-left">
                <div class="bottom-btn" @click="goHome">
                    <img src="/static/product/home.png" alt="" class="icon">
                    <span class="bottom-tit">首页</span>
                </div>
                <div class="bottom-btn" @click="openService">
                    <img src="/static/product/cart.png" alt="" class="icon">
                    <span class="bottom-tit">购物车</span>
                </div>
            </div>
            <div class="rent-btn" @click="showSpecPopup">立即购买</div>
        </div>

        <!-- 规格选择弹窗 -->
        <div class="modal" v-if="specVisible" @click.self="hideSpecPopup">
            <div class="modal-container">
                <div class="modal-header">
                    <div class="modal-left">
                        <img src="/static/product/shopimg.png" alt=""
                            style="width: 80px; height: 80px;margin-right: 10px;">
                        <div class="modal-right">
                            <div class="shop-price">6800 <span style="font-size: 12px;">积分</span></div>
                            <div class="shop-inventory">库存19件</div>
                            <div class="shop-detail">已选：{{ selectedCapacity }} {{ selectedColor }}</div>
                        </div>
                    </div>
                    <div class="close" @click="hideSpecPopup">✕</div>
                </div>
                <div class="modal-content">
                    <div class="spec-group">
                        <div class="group-title">规格</div>
                        <div class="spec-options">
                            <div :class="['spec-option', selectedCapacity === '智能款' ? 'active' : '']"
                                @click="selectedCapacity = '智能款'">智能款</div>
                            <div :class="['spec-option', selectedCapacity === '按键款' ? 'active' : '']"
                                @click="selectedCapacity = '按键款'">按键款</div>
                        </div>
                    </div>
                    <div class="spec-group">
                        <div class="group-title">颜色</div>
                        <div class="spec-options">
                            <div :class="['spec-option', selectedColor === '米色' ? 'active' : '']"
                                @click="selectedColor = '米色'">米色</div>
                            <div :class="['spec-option', selectedColor === '黑色' ? 'active' : '']"
                                @click="selectedColor = '黑色'">黑色</div>
                        </div>
                    </div>

                    <div class="spec-group-num">
                        <div class="group-title">兑换数量</div>
                        <div class="num-box">
                            <div class="num-btn" @click="decreaseNum">-</div>
                            <input type="number" class="num-input" v-model="selectedNum" min="1" />
                            <div class="num-btn" @click="increaseNum">+</div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="confirm-btn" @click="confirmSpec">确认下单</div>
                </div>
            </div>
        </div>
      
    </div>
</template>

<script>
export default {
    name: 'ProductDetail',
    data() {
        return {
            product: {
                images: [
                    '/static/product/detail.png',
                    '/static/product/detail.png',
                    '/static/product/detail.png'
                ],
                rentPrice: '0.99',
                title: '荣事达电饭煲5L',
                subtitle: '智能预约 大火力 不粘内胆 可拆洗上盖',
                originPrice: '199'
            },
            isFavorite: false,
            shopInfo: {
                name: '荣事达官方旗舰店',
                score: '9.68'
            },
            evaluations: [
                {
                    avatar: 'https://randomuser.me/api/portraits/women/1.jpg',
                    nickname: '**生',
                    content: '荣事达电饭煲很好用，煮饭快，内胆不粘，5L容量足够全家使用。',
                    skuInfo: '规格：125g  产地：云南红河（以实际购买商品批次为准）'
                },
                {
                    avatar: 'https://randomuser.me/api/portraits/men/2.jpg',
                    nickname: '小**子',
                    content: '物流很快，外观漂亮，还送了蓝莓果干，味道不错。',
                    skuInfo: '规格：125g  产地：云南红河（以实际购买商品批次为准）'
                }
            ],
            activeSimilarTab: 'similar',
            similarProductList: [
                { id: 1, title: '荣事达电煮锅一体锅多功能电炒锅家用火锅电锅蒸煮炒煎电热火锅', spec: '加热块 | 更方便快捷', image: '/static/home/Rectangle 1384.png', price: 0.01, points: null, oldPrice: 15.09 },
                { id: 2, title: '小熊蒸蛋器2025新款自动断电煮蛋器家用小型蒸锅一体玉米鸡蛋神器', spec: '可蒸煮 | 一键易操作', image: '/static/home/zhengdan.png', price: 0.01, points: 550, oldPrice: 15.09 },
                { id: 3, title: '小熊养生壶炖煮一体煮茶壶2026新款保温家用烧水壶官方旗舰店正品', spec: '0胶水更安心 | 入口安全有保障', image: '/static/home/zhucha.png', price: 0.01, points: 3793, oldPrice: 15.09 },
                { id: 4, title: '法国红酒整箱干红葡萄酒赤霞珠红酒14度官方正品旗舰店礼盒装送礼', spec: '果香浓郁 | 口感顺滑', image: '/static/home/hongjiu.png', price: 0.01, points: 1620, oldPrice: 15.09 },
                { id: 5, title: 'SHAREDNOTES生椰莫斯卡托甜白葡萄酒北欧风浮雕瓶椰子果酒6度微醺', spec: '椰子果香 | 清爽不腻', image: '/static/home/tianjiu.png', price: 0.01, points: 550, oldPrice: 15.09 },
                { id: 6, title: '智能空气炸锅', spec: '无油烹饪 销量冠军', image: '/static/home/Rectangle 1384.png', price: 0.01, points: null, oldPrice: 15.09 }
            ],
            oftenBuyList: [
                { id: 1, title: '荣事达电煮锅一体锅多功能电炒锅家用火锅电锅蒸煮炒煎电热火锅', spec: '加热块 | 更方便快捷', image: '/static/home/Rectangle 1384.png', price: 0.01, points: null, oldPrice: 15.09 },
                { id: 2, title: '小熊蒸蛋器2025新款自动断电煮蛋器家用小型蒸锅一体玉米鸡蛋神器', spec: '可蒸煮 | 一键易操作', image: '/static/home/zhengdan.png', price: 0.01, points: 550, oldPrice: 15.09 },
                { id: 3, title: '小熊养生壶炖煮一体煮茶壶2026新款保温家用烧水壶官方旗舰店正品', spec: '0胶水更安心 | 入口安全有保障', image: '/static/home/zhucha.png', price: 0.01, points: 3793, oldPrice: 15.09 },
                { id: 4, title: '法国红酒整箱干红葡萄酒赤霞珠红酒14度官方正品旗舰店礼盒装送礼', spec: '果香浓郁 | 口感顺滑', image: '/static/home/hongjiu.png', price: 0.01, points: 1620, oldPrice: 15.09 },
                { id: 5, title: 'SHAREDNOTES生椰莫斯卡托甜白葡萄酒北欧风浮雕瓶椰子果酒6度微醺', spec: '椰子果香 | 清爽不腻', image: '/static/home/tianjiu.png', price: 0.01, points: 550, oldPrice: 15.09 },
                { id: 6, title: '智能空气炸锅', spec: '无油烹饪 销量冠军', image: '/static/home/Rectangle 1384.png', price: 0.01, points: null, oldPrice: 15.09 }
            ],
            specVisible: false,
            serviceVisible: false,
            selectedCapacity: '智能款',
            selectedColor: '米色',
            serviceQrCode: 'https://picsum.photos/200/200?random=99',
            currentIndex: 0,
            scrollTimer: null,
            selectedNum: 1
        };
    },
    mounted() {
        this.initScrollListener();
    },
    beforeDestroy() {
        if (this.scrollTimer) clearTimeout(this.scrollTimer);
        const container = this.$refs.scrollContainer;
        if (container) {
            container.removeEventListener('scroll', this.onScroll);
        }
    },
    methods: {
        decreaseNum() {
            if (this.selectedNum > 1) {
                this.selectedNum--;
            }
        },
        increaseNum() {
            this.selectedNum++;
        },
        initScrollListener() {
            const container = this.$refs.scrollContainer;
            if (container) {
                container.addEventListener('scroll', this.onScroll);
            }
        },
        onScroll() {
            if (this.scrollTimer) clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => {
                const container = this.$refs.scrollContainer;
                if (container) {
                    const scrollLeft = container.scrollLeft;
                    const itemWidth = container.clientWidth;
                    const index = Math.round(scrollLeft / itemWidth);
                    this.currentIndex = Math.min(Math.max(index, 0), this.product.images.length - 1);
                }
            }, 50);
        },
        goBack() {
            window.history.back();
        },
        handleShare() {
            alert('分享功能');
        },
        toggleFavorite() {
            this.isFavorite = !this.isFavorite;
            alert(this.isFavorite ? '已收藏' : '已取消收藏');
        },
        gotoShop() {
            alert('进入店铺');
        },
        showSpecPopup() {
            this.specVisible = true;
        },
        hideSpecPopup() {
            this.specVisible = false;
        },
        confirmSpec() {
            this.hideSpecPopup();
            this.$router.push('/confirm');
        },
        gotoAllEvals() {
            alert('查看全部评价');
        },
        gotoProduct(id) {
            let product = null;
            if (this.activeSimilarTab === 'similar') {
                product = this.similarProductList.find(p => p.id === id);
            } else {
                product = this.oftenBuyList.find(p => p.id === id);
            }
            if (product) {
                alert(`查看商品：${product.title}`);
            } else {
                alert('查看商品详情');
            }
        },
        goHome() {
            this.$router.push('/');
        },
        openService() {
            this.serviceVisible = true;
        },
        hideServicePopup() {
            this.serviceVisible = false;
        }
    }
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
}

body {
    background-color: #f5f5f5;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.product-detail {
    max-width: 450px;
    margin: 0 auto;
    background-color: #f8f8f8;
    padding-bottom: 80px;
    position: relative;
}

/* 自定义头部（参考首页） */
.custom-header {
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background-color: #fff;
    border-bottom: 1px solid #f0f0f0;
}

.back-btn,
.share-btn {
    cursor: pointer;
    font-size: 16px;
    color: #333;
}

.header-title {
    font-size: 17px;
    font-weight: 500;
}

.back-btn .icon {
    font-size: 24px;
}

/* 图片轮播 */
.image-gallery {
    position: relative;
    width: 100%;
    overflow: hidden;
    background: #fff;
}

.scroll-container {
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
}

.scroll-container::-webkit-scrollbar {
    display: none;
}

.image-list {
    display: flex;
    width: 100%;
}

.image-item {
    flex: 0 0 100%;
    scroll-snap-align: start;
    position: relative;
}

.image-item img {
    width: 100%;
    height: auto;
    display: block;
    background: #e0e0e0;
}

.image-counter {
    position: absolute;
    bottom: 16px;
    right: 16px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 20px;
}

.dots {
    display: flex;
    justify-content: center;
    gap: 8px;
    padding: 12px 0;
    background: #fff;
}

.dot {
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background: #ccc;
    transition: all 0.2s;
}

.dot.active {
    width: 16px;
    background: #06cf33;
}

/* 卡片通用样式 */
.evaluation-card,
.similar-card {
    background: #fff;
    margin: 12px 16px;
    border-radius: 16px;
    padding: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);
}

.info-card {
    position: relative;
    background: linear-gradient(to bottom, #02983F 0%, #08753C 100%);
    margin: 12px 16px;
    border-radius: 18px;
    padding-top: 16px;
}

.price-tit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #FFFFFF;
    margin: 0 16px 14px;
}

.price-content {
    font-weight: 400;
    font-size: 18px;
}

.price-btn {
    font-weight: 600;
    font-size: 10px;
    color: #FFFFFF;
}

.old-price {
    font-size: 11px;
    color: #878787;
    text-decoration: line-through;
}

/* 商品信息 */
.price-row {
    background-color: #fff;
    border-radius: 18px;
    padding: 8px 16px 12px;
}

.price-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 8px;
}

.rent-price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
}

.rent-price .currency {
    display: flex;
    align-items: center;
}

.rent-price .price-num {
    height: 16px;
    text-align: center;
    line-height: 16px;
    padding: 0px 4px;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #FF0A0A;
    font-weight: 600;
    font-size: 9px;
    color: #FF0909;
    margin-right: 8px;
}

.rent-price .unit {
    font-size: 10px;
    color: #FF0C0C;
    font-weight: 600;
}

.collect-btn {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
}

.collect-icon {
    height: 12px;
    padding: 0 2px;
    font-size: 9px;
    background: #00A264;
    border-radius: 3px 3px 3px 3px;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 12px;
    text-align: center;
    margin-right: 8px;
}

.title {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
}

.subtitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.delivery-info {
    display: flex;
    gap: 16px;
    font-size: 12px;
    color: #999;
    padding-top: 12px;
    border-top: 1px solid #eee;
}

/* 特色标签 */
.feature-tags {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #F2F9FF;
    border-radius: 5px 5px 5px 5px;
    flex: 1;
    margin-right: 10px;
}

.tag-item {
    text-align: center;
}

.tag-name {
    font-size: 11px;
    font-weight: 500;
    color: #333;
    margin-bottom: 4px;
}

.tag-desc {
    font-size: 9px;
    color: #999;
}

.division {
    width: 0;
    height: 24px;
    border: 1px solid #E9E9E9;
    margin: 0 12px;
}

.ranking {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 10px;
    background: #FFF2E5;
    border-radius: 5px 5px 5px 5px;
}

.ranking-num {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 6px;
}

.ranking-tit {
    font-weight: 700;
    font-size: 12px;
    color: #923B09;
    line-height: 16px;
}

.ranking-cont {
    font-weight: 400;
    font-size: 12px;
    color: #923B09;
}

.ranking-icon {
    font-size: 8px;
}

/* 高山种植描述 */
.desc-card {
    font-size: 10px;
    color: #00A264;
    font-weight: 700;
    text-align: left;
}

/* 店铺与承诺 */
.shop-card {
    background-color: #fff;
    border-radius: 18px;
    padding: 8px 16px 12px;
    margin: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.shop-info {
    display: flex;
    align-items: center;
}

.shop-left {
    display: flex;
    flex-direction: column;
    align-items: start;
}

.shop-name {
    font-weight: 500;
    font-size: 12px;
    color: #333333;
    margin-bottom: 6px;
}

.shop-score {
    font-weight: 500;
    font-size: 10px;
    color: #ADADAD;
}

.shop-right {
    height: 28px;
    background: rgba(255, 102, 0, 0.16);
    border-radius: 14px 14px 14px 14px;
    padding: 0 10px;
    line-height: 28px;
    font-weight: 500;
    font-size: 10px;
    color: #FF6600;
}

.arrow {
    font-size: 20px;
    color: #ccc;
}

.promise-info {
    display: flex;
    align-items: center;
    padding: 16px;
    font-size: 14px;
}

.promise-title {
    font-weight: 500;
    margin-right: 16px;
}

.promise-content {
    flex: 1;
    color: #666;
}

/* 相似商品选项卡样式 */
.similar-tabs {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 32px;
    margin-bottom: 20px;
    padding-bottom: 6px;
}

.tab-item {
    position: relative;
    cursor: pointer;
}

.tab {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    transition: all 0.2s;
}

.tab.active {
    font-weight: 700;
    font-size: 18px;
    color: #000;
}

.tab-bar {
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 100%;
    height: 4px;
    background: #FF6600;
    border-radius: 2px;
}

/* 相似商品网格布局（一行3个） */
.similar-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

.similar-item {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #ADADAD;
    padding-bottom: 10px;
}

.similar-item:active {
    transform: scale(0.98);
}

.similar-img {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    background: #e9e9e9;
}

.similar-title {
    font-size: 12px;
    font-weight: 500;
    padding: 8px 8px 2px;
    white-space: normal;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: left;
}

.similar-spec {
    font-size: 10px;
    color: #999;
    padding: 0 8px 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
}

.price-tag {
    height: 10px;
    border-radius: 2px;
    border: 1px solid #FF0000;
    text-align: center;
    color: #FF0000;
    font-size: 5px;
    margin-right: 6px;
    padding: 0 3px;
}

.similar-price {
    font-size: 13px;
    color: #ff3b2f;
    font-weight: 600;
    padding: 0 8px 12px;
}

.add {
    width: 17px;
    height: 17px;
    background: #06CF33;
    border-radius: 50%;
    line-height: 17px;
    text-align: center;
    color: #fff;
    font-size: 18px;
}

.current-price {
    font-size: 18px;
    font-weight: 800;
    color: #ff3b2f;
}

/* 商品详情 */
.detail-card {
    background: #fff;
    margin: 12px 16px;
    border-radius: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);
}

.detail-img {
    width: 100%;
    border-radius: 16px;
}

/* 评价区域 */
.eval-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
}

.eval-title {
    font-size: 16px;
    font-weight: 600;
}

.eval-more {
    font-size: 12px;
    color: #999;
}

.eval-item {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
}

.eval-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ddd;
}

.eval-right {
    flex: 1;
}

.eval-name {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
}

.eval-content {
    font-size: 14px;
    color: #333;
    margin-bottom: 6px;
}

.eval-sku {
    font-size: 11px;
    color: #aaa;
}

/* 底部栏 */
.bottom-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 450px;
    margin: 0 auto;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    padding-bottom: calc(8px + env(safe-area-inset-bottom));
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    z-index: 99;
}

.bottom-left {
    display: flex;
    gap: 30px;
}

.bottom-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
    color: #666;
    cursor: pointer;
}

.bottom-btn .icon {
    width: 32px;
    height: 32px;
    margin-bottom: 2px;
}

.bottom-tit {
    font-weight: 500;
    font-size: 12px;
    color: #000000;
}

.rent-btn {
    background: #06CF33;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    padding: 10px 50px;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(6, 207, 51, 0.3);
    cursor: pointer;
}

/* 弹窗样式 */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 20px 20px 0 0;
    padding: 20px;
    animation: slideUp 0.3s;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
}

.modal-left {
    display: flex;
    align-items: center;
}

.modal-right {
    display: flex;
    flex-direction: column;
}

.shop-price {
    font-weight: 700;
    font-size: 24px;
    color: #FF0000;
    text-align: left;
    margin-bottom: 6px;
}

.shop-inventory {
    font-weight: 500;
    font-size: 11px;
    color: #979797;
    text-align: left;
    margin-bottom: 6px;
}

.shop-detail {
    font-weight: 700;
    font-size: 11px;
    color: #333333;
    text-align: left;
    margin-bottom: 6px;
}


.close {
    font-size: 22px;
    cursor: pointer;
}

.spec-group {
    margin-bottom: 20px;
}

.group-title {
    margin-bottom: 12px;
    text-align: left;
    font-weight: 700;
    font-size: 14px;
    color: #333333;
}

.spec-options {
    display: flex;
    gap: 12px;
}

.num-box {
    display: flex;
    align-items: center;
}

.num-btn {
    width: 20px;
    height: 20px;
    border: 1px solid #C4C4C4;
    line-height: 20px;
    color: #000000;
    font-size: 12px;
    text-align: center;
}

.num-input {
    width: 40px;
    height: 20px;
    text-align: center;
    color: #000000;
    font-size: 12px;
    border: 1px solid #C4C4C4;
}

.spec-group-num {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.spec-option {
    background: #f5f5f5;
    padding: 8px 20px;
    font-size: 14px;
    cursor: pointer;
}

.spec-option.active {
    background: #06cf33;
    color: #fff;
}

.price-info {
    font-size: 14px;
    color: #ff3b2f;
    margin-top: 16px;
}

.modal-footer {
    margin-top: 24px;
}

.confirm-btn {
    background: #06cf33;
    text-align: center;
    color: #fff;
    padding: 6px;
    font-size: 16px;
    border-radius: 40px;
    font-weight: 600;
    cursor: pointer;
}

.qr-container {
    background: #fff;
    padding: 24px;
    border-radius: 20px;
    text-align: center;
    width: 260px;
}

.qr-image {
    width: 200px;
    height: 200px;
}

.qr-tip {
    margin-top: 12px;
    font-size: 14px;
    color: #666;
}

@keyframes slideUp {
    from {
        transform: translateY(100%);
    }

    to {
        transform: translateY(0);
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Detail.vue